import { useEffect } from 'react';
import Bowser from 'bowser';
import { omitBy } from 'lodash-es';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/hooks/useLocale';
import { useCountryCode } from '@/shared/hooks';
import { getStoredQuizTrackingUserProperties } from '@/shared/trackingContext';
import { getApplicationSessionId, getBrowserSessionId, getDeviceId } from '@/utils/common';
export const QuizAppLoggerInitializer = () => {
  const {
    locale
  } = useLocale();
  const {
    countryCode
  } = useCountryCode();
  useEffect(() => {
    const applicationSessionId = getApplicationSessionId();
    const browserSessionId = getBrowserSessionId();
    const deviceId = getDeviceId();

    // UTM은 shared/logger 모듈 로드 시점에 이미 logger state로 동기 주입됨.
    // 여기서는 user property 기록을 위해 저장된 값을 다시 읽어 전달만 한다.
    const {
      browser,
      os
    } = Bowser.parse(window.navigator.userAgent);
    logger.setState({
      zep_application_session_id: applicationSessionId,
      zep_browser_session_id: browserSessionId,
      zepApplicationSessionId: applicationSessionId,
      zepBrowserSessionId: browserSessionId,
      zepDeviceId: deviceId
    });
    logger.setUserProperties({
      ...omitBy(getStoredQuizTrackingUserProperties(), v => !v),
      zep_user_agent: window.navigator.userAgent,
      zep_browser_name: browser.name,
      zep_browser_version: browser.version,
      zep_os_name: os.name,
      zep_os_version: os.version
    });
    logger.setTag('zep_application_session_id', applicationSessionId);
    logger.setTag('zep_browser_session_id', browserSessionId);
  }, []);
  useEffect(() => {
    logger.setUserProperties({
      zep_country_code: countryCode,
      zep_locale: locale
    });
  }, [countryCode, locale]);
  return null;
};